module.exports = __webpack_public_path__ + "img/man-with-son.f6c9f736.png";